import { render, staticRenderFns } from "./ListAllRequests.vue?vue&type=template&id=21289d22&"
import script from "./ListAllRequests.vue?vue&type=script&lang=js&"
export * from "./ListAllRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports